<template>
    <ui-dropdown :menu-class="menuClass">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>
        <template #menu="dropdownScope">
            <slot name="menu" v-bind="scope(dropdownScope)">
                <div class="text-sm text-gray-700">
                    {{ dateFormatted }}
                </div>
            </slot>
        </template>
    </ui-dropdown>
</template>

<script>
export default {
    props: {
        moment: Object,
        menuClass: String,
        format: {
            type: String,
            default: 'llll',
        }
    },
    methods: {
        scope (dropdownScope) {
            return {
                ...dropdownScope,
                dateFormatted: this.dateFormatted,
                dateAgo: this.dateAgo,
            }
        },
    },
    computed: {
        dateFormatted () {
            return this.moment.format(this.format)
        },
        dateAgo () {
            return this.moment.fromNow()
        },
    },
}
</script>
